import { keepPreviousData } from '@tanstack/react-query';
import { fetchEmailRecipientsList } from '@/lib/api/email-flows';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import type { EmailRecipientsListResponse, RecipientsListParams } from '../types';
import { useStanQuery } from '@/queries';

/**
 * Query hook for fetching email-specific recipients list
 * Shows who received a particular email in a flow
 */
export const useEmailRecipients = (emailId: number, params: Omit<RecipientsListParams, 'flow_email_id'>) => {
    return useStanQuery<EmailRecipientsListResponse>({
        queryKey: [QUERY_KEYS.RECIPIENTS_LIST, 'email', emailId, params],
        queryFn: () => fetchEmailRecipientsList(emailId, params),
        staleTime: 5 * 60 * 1000, // 5 minutes
        placeholderData: keepPreviousData,
        enabled: emailId > 0,
        meta: {
            error: {
                sentryMessage: '[EMAIL_FLOWS] failed-to-fetch-email-recipients',
                feature: SENTRY_FEATURES.EMAIL_FLOWS,
            },
        },
    });
};
